(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    

$('#paginateby').on('change', function(){
var val = $(this).val();

$.ajax({
type: "POST",
url: 'https://unsimplystitched.com/cart.js',

data: {"attributes[pagination]": val},
success: function(d){
window.location.reload();
},
dataType: 'json'
});
});

  } catch(e) { console.error(e); }
})();
})();
